export default {
    ADDULTS: 'addults',
    CHILDREN: 'children',
    BABY: 'baby',
    TEENAGERS: 'teenagers',
}